// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Map = require("rescript/lib/js/belt_Map.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.bs.js");
var CryptoJs$SmartcutsMacros = require("../../../bs-crypto-js/src/CryptoJs.bs.js");
var Password$SmartcutsMacros = require("../Password.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../../bs-utils/src/ArrayUtils.bs.js");
var CustomMap2$SmartcutsMacros = require("../CustomMap2.bs.js");
var DeccoUtils$SmartcutsMacros = require("../../../bs-utils/src/DeccoUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var VaultHelpers$SmartcutsMacros = require("./VaultHelpers.bs.js");
var DataStoreUtils$SmartcutsMacros = require("../../../data/src/DataStoreUtils.bs.js");
var UserCredential__Shared$SmartcutsMacros = require("../UserCredential__Shared.bs.js");

function secureData_encode(encoder_otherSecretData, v) {
  if (typeof v === "number") {
    return ["NothingToEncrypt"];
  }
  switch (v.TAG | 0) {
    case /* Password */0 :
        return [
                "Password",
                Password$SmartcutsMacros.t_encode(v._0)
              ];
    case /* PasswordWithSecretData */1 :
        return [
                "PasswordWithSecretData",
                Password$SmartcutsMacros.t_encode(v._0),
                Curry._1(encoder_otherSecretData, v._1)
              ];
    case /* SecretData */2 :
        return [
                "SecretData",
                Curry._1(encoder_otherSecretData, v._0)
              ];
    
  }
}

function secureData_decode(decoder_otherSecretData, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "NothingToEncrypt" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NothingToEncrypt */0
                  };
          }
      case "Password" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Password$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Password */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "PasswordWithSecretData" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Password$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Curry._1(decoder_otherSecretData, Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* PasswordWithSecretData */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "SecretData" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(decoder_otherSecretData, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SecretData */2,
                      _0: v0$1._0
                    }
                  };
          }
          var e$3 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function payloadToEncrypt_encode(encoder_otherSecretData, v) {
  return Js_dict.fromArray([
              [
                "secureData",
                secureData_encode(encoder_otherSecretData, v.secureData)
              ],
              [
                "loginStatus",
                UserCredential__Shared$SmartcutsMacros.loginStatus_encode(v.loginStatus)
              ]
            ]);
}

function payloadToEncrypt_decode(decoder_otherSecretData, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var secureData = secureData_decode(decoder_otherSecretData, Belt_Option.getWithDefault(Js_dict.get(dict$1, "secureData"), null));
  if (secureData.TAG === /* Ok */0) {
    var loginStatus = UserCredential__Shared$SmartcutsMacros.loginStatus_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "loginStatus"), null));
    if (loginStatus.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                secureData: secureData._0,
                loginStatus: loginStatus._0
              }
            };
    }
    var e = loginStatus._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".loginStatus" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = secureData._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".secureData" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function encryptedStatus_encode(encoder_value, v) {
  if (v) {
    return [
            "EncryptedValue",
            Curry._1(encoder_value, v._0)
          ];
  } else {
    return ["EncryptedValueOutdatedDueToSecretReset"];
  }
}

function encryptedStatus_decode(decoder_value, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "EncryptedValue" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(decoder_value, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* EncryptedValue */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "EncryptedValueOutdatedDueToSecretReset" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* EncryptedValueOutdatedDueToSecretReset */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function mapEncryptedStatus(status, f) {
  if (status) {
    return /* EncryptedValue */{
            _0: Curry._1(f, status._0)
          };
  } else {
    return /* EncryptedValueOutdatedDueToSecretReset */0;
  }
}

function error_encode(v) {
  if (typeof v !== "object") {
    if (v === "VaultNotInitialized") {
      return ["VaultNotInitialized"];
    } else if (v === "IncorrectMasterSecret") {
      return ["IncorrectMasterSecret"];
    } else {
      return ["VaultAlreadyExists"];
    }
  }
  var variant = v.NAME;
  if (variant === "DeccoDecodeError") {
    return [
            "DeccoDecodeError",
            DeccoUtils$SmartcutsMacros.SerializableDeccoDecodeError.t_encode(v.VAL)
          ];
  } else if (variant === "JsonDecodeError") {
    return [
            "JsonDecodeError",
            Decco.stringToJson(v.VAL)
          ];
  } else {
    return [
            "FaunaGraphqlError",
            DataStoreUtils$SmartcutsMacros.FaunaGraphqlError.t_encode(v.VAL)
          ];
  }
}

function error_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a polyvariant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a polyvariant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected polyvariant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DeccoDecodeError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to polyvariant constructor", v);
          }
          var v0 = DeccoUtils$SmartcutsMacros.SerializableDeccoDecodeError.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      NAME: "DeccoDecodeError",
                      VAL: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "FaunaGraphqlError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to polyvariant constructor", v);
          }
          var v0$1 = DataStoreUtils$SmartcutsMacros.FaunaGraphqlError.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      NAME: "FaunaGraphqlError",
                      VAL: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "IncorrectMasterSecret" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to polyvariant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: "IncorrectMasterSecret"
                  };
          }
      case "JsonDecodeError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to polyvariant constructor", v);
          }
          var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      NAME: "JsonDecodeError",
                      VAL: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "VaultAlreadyExists" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to polyvariant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: "VaultAlreadyExists"
                  };
          }
      case "VaultNotInitialized" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to polyvariant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: "VaultNotInitialized"
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid polyvariant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function humanReasonForError(error) {
  if (typeof error !== "object") {
    if (error === "VaultNotInitialized") {
      return "Vault not initialized";
    } else if (error === "IncorrectMasterSecret") {
      return "Incorrect master secret";
    } else {
      return "Value already exists";
    }
  }
  var variant = error.NAME;
  if (variant === "DeccoDecodeError") {
    return "Could not decode: " + error.VAL.message;
  } else if (variant === "JsonDecodeError") {
    return "Could not decode json: " + error.VAL;
  } else {
    return DataStoreUtils$SmartcutsMacros.FaunaGraphqlError.toHumanReadable(error.VAL);
  }
}

function value_encode(encoder_otherSecretData, v) {
  return encryptedStatus_encode((function (param) {
                return payloadToEncrypt_encode(encoder_otherSecretData, param);
              }), v);
}

function value_decode(decoder_otherSecretData, v) {
  return encryptedStatus_decode((function (param) {
                return payloadToEncrypt_decode(decoder_otherSecretData, param);
              }), v);
}

function t_encode(encoder_otherSecretData, v) {
  return Curry._2(CustomMap2$SmartcutsMacros.MapCredentialDbId.t_encode, (function (param) {
                return value_encode(encoder_otherSecretData, param);
              }), v);
}

function t_decode(decoder_otherSecretData, v) {
  return Curry._2(CustomMap2$SmartcutsMacros.MapCredentialDbId.t_decode, (function (param) {
                return value_decode(decoder_otherSecretData, param);
              }), v);
}

function view(x) {
  return x;
}

function minify(vault, minifyOtherSecretData) {
  return Belt_Map.map(vault, (function (value) {
                if (!value) {
                  return value;
                }
                var match = value._0;
                var secureData = match.secureData;
                var tmp;
                if (typeof secureData === "number") {
                  tmp = /* NothingToEncrypt */0;
                } else {
                  switch (secureData.TAG | 0) {
                    case /* Password */0 :
                        tmp = {
                          TAG: /* Password */0,
                          _0: Password$SmartcutsMacros.fromString("*")
                        };
                        break;
                    case /* PasswordWithSecretData */1 :
                        tmp = {
                          TAG: /* PasswordWithSecretData */1,
                          _0: Password$SmartcutsMacros.fromString("*"),
                          _1: Curry._1(minifyOtherSecretData, secureData._1)
                        };
                        break;
                    case /* SecretData */2 :
                        tmp = {
                          TAG: /* SecretData */2,
                          _0: Curry._1(minifyOtherSecretData, secureData._0)
                        };
                        break;
                    
                  }
                }
                return /* EncryptedValue */{
                        _0: {
                          secureData: tmp,
                          loginStatus: match.loginStatus
                        }
                      };
              }));
}

function encryptionKey(masterSecret, storageKey) {
  var keyWithPrefix = VaultHelpers$SmartcutsMacros.keyPrefix + VaultHelpers$SmartcutsMacros.storageKeyToString(storageKey);
  return "" + "[5H[`lC2v4W~-6t8V#/OY=4mwUNfFG" + masterSecret + "X|(TtzvTNsMX=/}ub=YTj95PK7og8C" + keyWithPrefix + "W2>FKRrW}I?YCSvK2vs]@sd]'ZbqCN";
}

function decryptJson(masterSecret, storageKey, encryptedMessage) {
  try {
    var decrypted = CryptoJs$SmartcutsMacros.AES.decryptString(encryptedMessage, encryptionKey(masterSecret, storageKey), undefined, undefined);
    if (decrypted === "") {
      return {
              TAG: /* Error */1,
              _0: "IncorrectMasterSecret"
            };
    } else {
      return {
              TAG: /* Ok */0,
              _0: JSON.parse(decrypted)
            };
    }
  }
  catch (exn){
    return {
            TAG: /* Error */1,
            _0: "IncorrectMasterSecret"
          };
  }
}

function encryptJson(masterSecret, storageKey, json) {
  return CryptoJs$SmartcutsMacros.AES.encryptString(JSON.stringify(json), encryptionKey(masterSecret, storageKey));
}

function toJson(param) {
  return Json_encode.object_({
              hd: [
                "key",
                param.key
              ],
              tl: {
                hd: [
                  "needsToBeReentered",
                  param.needsToBeReentered === /* DoesNeedToBeReentered */0
                ],
                tl: /* [] */0
              }
            });
}

function fromJson(json) {
  return {
          key: Json_decode.field("key", Json_decode.string, json),
          needsToBeReentered: Json_decode.field("needsToBeReentered", Json_decode.bool, json) ? /* DoesNeedToBeReentered */0 : /* DoesNotNeedToBeReentered */1
        };
}

var empty = [];

function fetchIndex(param) {
  return VaultHelpers$SmartcutsMacros.readFromStorage(/* Indexes */0).then(function (maybestring) {
              if (maybestring === undefined) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: "VaultNotInitialized"
                          });
              }
              var index = Json_decode.array(fromJson, JSON.parse(maybestring));
              return Promise.resolve({
                          TAG: /* Ok */0,
                          _0: index
                        });
            });
}

function readAllFromStorage(storageKeys) {
  return browser.storage.local.get(Belt_Array.map(storageKeys, (function (storageKey) {
                    return VaultHelpers$SmartcutsMacros.keyPrefix + VaultHelpers$SmartcutsMacros.storageKeyToString(storageKey);
                  })));
}

var empty$1 = [empty];

function kvPairsToWriteToStorage(indexes) {
  var keyWithPrefix = VaultHelpers$SmartcutsMacros.keyPrefix + VaultHelpers$SmartcutsMacros.storageKeyToString(/* Indexes */0);
  return Belt_Array.map(indexes, (function (index) {
                return [
                        keyWithPrefix,
                        JSON.stringify(Json_encode.array(toJson, index))
                      ];
              }));
}

function writeToStorage(indexes) {
  return browser.storage.local.set(Json_encode.object_($$Array.to_list(kvPairsToWriteToStorage(indexes))));
}

function writeToStorageEncrypted(masterSecret, encodeOtherSecretData, data) {
  return browser.storage.local.set(Json_encode.object_($$Array.to_list(Belt_Array.map(data, (function (storageItem) {
                            if (storageItem) {
                              var storageKey = /* Key */{
                                _0: storageItem._0
                              };
                              var keyWithPrefix = VaultHelpers$SmartcutsMacros.keyPrefix + VaultHelpers$SmartcutsMacros.storageKeyToString(storageKey);
                              return [
                                      keyWithPrefix,
                                      encryptJson(masterSecret, storageKey, encryptedStatus_encode((function (param) {
                                                  return payloadToEncrypt_encode(encodeOtherSecretData, param);
                                                }), storageItem._1))
                                    ];
                            }
                            var keyWithPrefix$1 = VaultHelpers$SmartcutsMacros.keyPrefix + VaultHelpers$SmartcutsMacros.storageKeyToString(/* ValidationKey */1);
                            return [
                                    keyWithPrefix$1,
                                    encryptJson(masterSecret, /* ValidationKey */1, VaultHelpers$SmartcutsMacros.storageKeyToString(/* ValidationKey */1))
                                  ];
                          })))));
}

function makeNew(masterSecret, encodeOtherSecretData) {
  return VaultHelpers$SmartcutsMacros.readFromStorage(/* Indexes */0).then(function (maybeString) {
              if (maybeString !== undefined) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: "VaultAlreadyExists"
                          });
              } else {
                return writeToStorageEncrypted(masterSecret, encodeOtherSecretData, [/* StorageValidationKey */0]).then(function (param) {
                              return writeToStorage(empty$1);
                            }).then(function (param) {
                            return Promise.resolve({
                                        TAG: /* Ok */0,
                                        _0: Curry._1(CustomMap2$SmartcutsMacros.MapCredentialDbId.make, undefined)
                                      });
                          });
              }
            });
}

function validate(masterSecret) {
  return VaultHelpers$SmartcutsMacros.readFromStorage(/* ValidationKey */1).then(function (maybeString) {
              if (maybeString === undefined) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: "VaultNotInitialized"
                          });
              }
              var value = decryptJson(masterSecret, /* ValidationKey */1, maybeString);
              if (value.TAG === /* Ok */0 && Caml_obj.caml_equal(Js_json.decodeString(value._0), VaultHelpers$SmartcutsMacros.storageKeyToString(/* ValidationKey */1))) {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: undefined
                          });
              } else {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: "IncorrectMasterSecret"
                          });
              }
            });
}

function checkIfAnyMasterSecretHasBeenSet(param) {
  return VaultHelpers$SmartcutsMacros.readFromStorage(/* ValidationKey */1).then(function (maybeString) {
              if (maybeString !== undefined) {
                return Promise.resolve(true);
              } else {
                return Promise.resolve(false);
              }
            });
}

function unlockExisting(masterSecret, decodeOtherSecretData) {
  return validate(masterSecret).then(function (validated) {
              if (validated.TAG === /* Ok */0) {
                return fetchIndex(undefined).then(function (result) {
                            if (result.TAG !== /* Ok */0) {
                              return Promise.resolve({
                                          TAG: /* Error */1,
                                          _0: result._0
                                        });
                            }
                            var param = result._0;
                            return readAllFromStorage(Belt_Array.map(param, (function (pair) {
                                                return /* Key */{
                                                        _0: pair.key
                                                      };
                                              }))).then(function (dict) {
                                        return Promise.resolve(Belt_Array.reduce(param, {
                                                        TAG: /* Ok */0,
                                                        _0: Curry._1(CustomMap2$SmartcutsMacros.MapCredentialDbId.make, undefined)
                                                      }, (function (currResult, param) {
                                                          var key = param.key;
                                                          return Belt_Result.flatMap(currResult, (function (decryptedValuesByKey) {
                                                                        var arg = Belt_Option.map(Js_dict.get(dict, key), (function (encryptedJson) {
                                                                                var func = function (param, param$1, param$2) {
                                                                                  var arg = Json_decode.string(param$2);
                                                                                  var decryptedJson = (function (param) {
                                                                                          return function (param$1) {
                                                                                            return decryptJson(param, param$1, arg);
                                                                                          };
                                                                                        })(masterSecret)(/* Key */{
                                                                                        _0: param
                                                                                      });
                                                                                  if (decryptedJson.TAG !== /* Ok */0) {
                                                                                    return {
                                                                                            TAG: /* Error */1,
                                                                                            _0: decryptedJson._0
                                                                                          };
                                                                                  }
                                                                                  var value = encryptedStatus_decode((function (param$3) {
                                                                                          return payloadToEncrypt_decode(param$1, param$3);
                                                                                        }), decryptedJson._0);
                                                                                  if (value.TAG === /* Ok */0) {
                                                                                    return {
                                                                                            TAG: /* Ok */0,
                                                                                            _0: value._0
                                                                                          };
                                                                                  } else {
                                                                                    return {
                                                                                            TAG: /* Error */1,
                                                                                            _0: {
                                                                                              NAME: "DeccoDecodeError",
                                                                                              VAL: DeccoUtils$SmartcutsMacros.SerializableDeccoDecodeError.fromDeccoDecodeError(value._0)
                                                                                            }
                                                                                          };
                                                                                  }
                                                                                };
                                                                                var func$1 = Curry._1(func, key);
                                                                                return Belt_Result.map(Curry._1((function (param) {
                                                                                                  return Curry._2(func$1, param, encryptedJson);
                                                                                                }), decodeOtherSecretData), (function (decryptedValue) {
                                                                                              return Belt_Map.set(decryptedValuesByKey, key, decryptedValue);
                                                                                            }));
                                                                              }));
                                                                        var param = {
                                                                          TAG: /* Ok */0,
                                                                          _0: decryptedValuesByKey
                                                                        };
                                                                        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                                                                      }));
                                                        })));
                                      });
                          });
              } else {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: validated._0
                          });
              }
            });
}

function resetMasterSecret(vault, masterSecret, encodeOtherSecretData) {
  return writeToStorageEncrypted(masterSecret, encodeOtherSecretData, [/* StorageValidationKey */0]).then(function (param) {
              return browser.storage.local.set(Json_encode.object_($$Array.to_list(Belt_Array.map(Belt_Map.toArray(vault), (function (param) {
                                          var storageKey = /* Key */{
                                            _0: param[0]
                                          };
                                          var keyWithPrefix = VaultHelpers$SmartcutsMacros.keyPrefix + VaultHelpers$SmartcutsMacros.storageKeyToString(storageKey);
                                          return [
                                                  keyWithPrefix,
                                                  encryptJson(masterSecret, storageKey, encryptedStatus_encode((function (param) {
                                                              return payloadToEncrypt_encode(encodeOtherSecretData, param);
                                                            }), param[1]))
                                                ];
                                        }))))).then(function (param) {
                          return Promise.resolve({
                                      TAG: /* Ok */0,
                                      _0: vault
                                    });
                        });
            });
}

function makeNewWithResetMasterSecret(masterSecret, encodeOtherSecretData) {
  return writeToStorageEncrypted(masterSecret, encodeOtherSecretData, [/* StorageValidationKey */0]).then(function (param) {
                return fetchIndex(undefined);
              }).then(function (result) {
              if (result.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result._0
                          });
              }
              var index_2 = Belt_Array.map(result._0, (function (pair) {
                      return {
                              key: pair.key,
                              needsToBeReentered: /* DoesNeedToBeReentered */0
                            };
                    }));
              var vault = Curry._1(CustomMap2$SmartcutsMacros.MapCredentialDbId.make, undefined);
              return browser.storage.local.set(Json_encode.object_($$Array.to_list($$Array.append(kvPairsToWriteToStorage([index_2]), Belt_Array.map(index_2, (function (param) {
                                              var storageKey = /* Key */{
                                                _0: param.key
                                              };
                                              var keyWithPrefix = VaultHelpers$SmartcutsMacros.keyPrefix + VaultHelpers$SmartcutsMacros.storageKeyToString(storageKey);
                                              return [
                                                      keyWithPrefix,
                                                      encryptJson(masterSecret, storageKey, ["EncryptedValueOutdatedDueToSecretReset"])
                                                    ];
                                            })))))).then(function (param) {
                          return Promise.resolve({
                                      TAG: /* Ok */0,
                                      _0: vault
                                    });
                        });
            });
}

function isEmpty(x) {
  return Belt_Map.size(x) === 0;
}

function encryptAndStoreSecureData(vault, masterSecret, encodeOtherSecretData, key, secureData) {
  return validate(masterSecret).then(function (validated) {
                if (validated.TAG === /* Ok */0) {
                  return fetchIndex(undefined).then(function (result) {
                              if (result.TAG !== /* Ok */0) {
                                return Promise.resolve({
                                            TAG: /* Error */1,
                                            _0: result._0
                                          });
                              }
                              var index = result._0;
                              var entryToAssign = {
                                key: key,
                                needsToBeReentered: /* DoesNotNeedToBeReentered */1
                              };
                              var i = Belt_Array.getIndexBy(index, (function (pair) {
                                      return Caml_obj.caml_equal(pair.key, key);
                                    }));
                              var index_v2 = i !== undefined ? ArrayUtils$SmartcutsMacros.setWithoutFill(i, entryToAssign, index) : $$Array.append(index, [entryToAssign]);
                              var storageKey = /* Key */{
                                _0: key
                              };
                              var keyWithPrefix = VaultHelpers$SmartcutsMacros.keyPrefix + VaultHelpers$SmartcutsMacros.storageKeyToString(storageKey);
                              return browser.storage.local.set(Json_encode.object_($$Array.to_list($$Array.append(kvPairsToWriteToStorage([index_v2]), [[
                                                          keyWithPrefix,
                                                          encryptJson(masterSecret, storageKey, encryptedStatus_encode((function (param) {
                                                                      return payloadToEncrypt_encode(encodeOtherSecretData, param);
                                                                    }), /* EncryptedValue */{
                                                                    _0: {
                                                                      secureData: secureData,
                                                                      loginStatus: /* NoLoginAttemptedYet */0
                                                                    }
                                                                  }))
                                                        ]])))).then(function (param) {
                                          return Promise.resolve({
                                                      TAG: /* Ok */0,
                                                      _0: undefined
                                                    });
                                        });
                            });
                } else {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: validated._0
                            });
                }
              }).then(function (result) {
              if (result.TAG === /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: Belt_Map.set(vault, key, /* EncryptedValue */{
                                  _0: {
                                    secureData: secureData,
                                    loginStatus: /* NoLoginAttemptedYet */0
                                  }
                                })
                          });
              } else {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result._0
                          });
              }
            });
}

function markKeyAsOutdatedDueToSecretReset(vault, masterSecret, encodeOtherSecretData, key) {
  return validate(masterSecret).then(function (validated) {
                if (validated.TAG !== /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: validated._0
                            });
                }
                var storageKey = /* Key */{
                  _0: key
                };
                var keyWithPrefix = VaultHelpers$SmartcutsMacros.keyPrefix + VaultHelpers$SmartcutsMacros.storageKeyToString(storageKey);
                return browser.storage.local.set(Json_encode.object_({
                                  hd: [
                                    keyWithPrefix,
                                    encryptJson(masterSecret, storageKey, ["EncryptedValueOutdatedDueToSecretReset"])
                                  ],
                                  tl: /* [] */0
                                })).then(function (param) {
                            return Promise.resolve({
                                        TAG: /* Ok */0,
                                        _0: undefined
                                      });
                          });
              }).then(function (result) {
              if (result.TAG === /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: Belt_Map.set(vault, key, /* EncryptedValueOutdatedDueToSecretReset */0)
                          });
              } else {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result._0
                          });
              }
            });
}

function remove(vault, masterSecret, key) {
  return validate(masterSecret).then(function (validated) {
                  if (validated.TAG === /* Ok */0) {
                    return fetchIndex(undefined).then(function (result) {
                                if (result.TAG !== /* Ok */0) {
                                  return Promise.resolve({
                                              TAG: /* Error */1,
                                              _0: result._0
                                            });
                                }
                                var index_v2 = Belt_Array.keep(result._0, (function (pair) {
                                        return Caml_obj.caml_notequal(pair.key, key);
                                      }));
                                return writeToStorage([index_v2]).then(function (param) {
                                            return Promise.resolve({
                                                        TAG: /* Ok */0,
                                                        _0: undefined
                                                      });
                                          });
                              });
                  } else {
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: validated._0
                              });
                  }
                }).then(function (result) {
                if (result.TAG !== /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: result._0
                            });
                }
                var storageKey = /* Key */{
                  _0: key
                };
                var keyWithPrefix = VaultHelpers$SmartcutsMacros.keyPrefix + VaultHelpers$SmartcutsMacros.storageKeyToString(storageKey);
                return browser.storage.local.remove(keyWithPrefix).then(function (param) {
                            return Promise.resolve({
                                        TAG: /* Ok */0,
                                        _0: undefined
                                      });
                          });
              }).then(function (result) {
              if (result.TAG === /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: Belt_Map.remove(vault, key)
                          });
              } else {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result._0
                          });
              }
            });
}

function update(vault, masterSecret, encodeOtherSecretData, key, fn) {
  return validate(masterSecret).then(function (validated) {
              if (validated.TAG !== /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: validated._0
                          });
              }
              var vault_2 = Belt_Map.update(vault, key, fn);
              var newValue = Belt_Map.get(vault_2, key);
              if (newValue !== undefined) {
                return writeToStorageEncrypted(masterSecret, encodeOtherSecretData, [/* Item */{
                                _0: key,
                                _1: newValue
                              }]).then(function (param) {
                            return Promise.resolve({
                                        TAG: /* Ok */0,
                                        _0: vault_2
                                      });
                          });
              } else {
                return remove(vault, masterSecret, key);
              }
            });
}

var keep = Belt_Map.keep;

function reEntryStatusFromEncryptedStatusAndLoginStatus(encryptedStatus, loginStatus) {
  if (encryptedStatus) {
    if (typeof loginStatus === "number") {
      return /* NotKnown */0;
    } else if (loginStatus.TAG === /* LoginSucceeded */0) {
      return /* DoesNotNeedToBeReentered */2;
    } else {
      return /* DoesNeedToBeReentered */1;
    }
  } else {
    return /* DoesNeedToBeReentered */1;
  }
}

var keysToArray = Belt_Map.keysToArray;

var toArray = Belt_Map.toArray;

var get = Belt_Map.get;

var has = Belt_Map.has;

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.secureData_encode = secureData_encode;
exports.secureData_decode = secureData_decode;
exports.payloadToEncrypt_encode = payloadToEncrypt_encode;
exports.payloadToEncrypt_decode = payloadToEncrypt_decode;
exports.encryptedStatus_encode = encryptedStatus_encode;
exports.encryptedStatus_decode = encryptedStatus_decode;
exports.mapEncryptedStatus = mapEncryptedStatus;
exports.error_encode = error_encode;
exports.error_decode = error_decode;
exports.humanReasonForError = humanReasonForError;
exports.value_encode = value_encode;
exports.value_decode = value_decode;
exports.view = view;
exports.minify = minify;
exports.validate = validate;
exports.checkIfAnyMasterSecretHasBeenSet = checkIfAnyMasterSecretHasBeenSet;
exports.makeNew = makeNew;
exports.unlockExisting = unlockExisting;
exports.resetMasterSecret = resetMasterSecret;
exports.makeNewWithResetMasterSecret = makeNewWithResetMasterSecret;
exports.isEmpty = isEmpty;
exports.keysToArray = keysToArray;
exports.toArray = toArray;
exports.get = get;
exports.has = has;
exports.encryptAndStoreSecureData = encryptAndStoreSecureData;
exports.markKeyAsOutdatedDueToSecretReset = markKeyAsOutdatedDueToSecretReset;
exports.remove = remove;
exports.update = update;
exports.keep = keep;
exports.reEntryStatusFromEncryptedStatusAndLoginStatus = reEntryStatusFromEncryptedStatusAndLoginStatus;
/* CryptoJs-SmartcutsMacros Not a pure module */
